import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

const Component = props => (
	<Grid
		item
		container
		xs={12}
		className="actionable-label"
		justify="space-between"
		wrap="nowrap"
		{...props}
	/>
);

export default styled(Component)`
	&.disabled {
		opacity: 0.34;
		user-select: none;
	}

	.label {
		display: flex;
		flex: 1 1 200px;
		align-items: center;
	}

	.label > p {
		font-weight: 600;
	}

	.tag {
		display: inline-block;
		margin: 0 8px;
		padding: 4px 6px;
		font-size: 12px;
		font-weight: 600;
		font-style: normal;
		font-stretch: normal;
		line-height: 1.33;
		letter-spacing: -0.3px;
		color: rgba(35, 22, 63, 0.9);
		background-color: rgba(235, 235, 237, 0.9);
		border-radius: 3px;
	}

	.description {
		margin-top: 8px;
	}

	.widget {
		text-align: right;
	}
`;
